import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import styles from "./styles/Navbar.module.scss";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineSearch } from "react-icons/ai";
import { IoIosSettings } from "react-icons/io";
import { TbLogout2 } from "react-icons/tb";
import { IoNotifications } from "react-icons/io5";
import { RiWallet3Line } from "react-icons/ri";

import { WEB_ROUTES } from "../../constants";
import { baseRoute } from "../../Helper";
import { fetchUnreadCount } from "../../redux/slices/notificationSlice";
import NotificationPanel from "../Modals/NotificationPanel";

export default function Navbar({
  isSearchBar = true,
  handleToggle,
  onLogoutClick,
}) {
  const dispatch = useDispatch();
  const portal = useSelector((state) => state.auth?.portal);
  const isAdmin = portal === "admin";
  const unreadCount = useSelector(
    (state) => state.notification?.unreadCount ?? 0
  );
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    if (isAdmin) {
      dispatch(fetchUnreadCount());
    }
  }, [dispatch, isAdmin]);

  return (
    <div className={styles.Navbar}>
      <div className={styles.titleContainer}>
        <span onClick={handleToggle} className={styles.toggleButton}>
          <GiHamburgerMenu />
        </span>
      </div>

      {isSearchBar ? (
        <div className={styles.search}>
          <div className={styles.searchButton}>
            <AiOutlineSearch />
          </div>
          <input type="text" placeholder="Search " />
        </div>
      ) : null}

      <div className={styles.navActions}>
        {isAdmin && (
          <>
              <Link
              to={baseRoute(WEB_ROUTES.WALLET)}
              className={`${styles.navIconButton} ${styles.walletButton}`}
              title="Wallet"
              aria-label="Wallet"
            >
              <RiWallet3Line />
              <span className={styles.walletLabel}>Wallet</span>
            </Link>
            <button
              type="button"
              className={`${styles.navIconButton} ${styles.bellButton}`}
              onClick={() => setShowPanel((prev) => !prev)}
              title="Notifications"
              aria-label="Notifications"
            >
              <IoNotifications />
              {unreadCount > 0 && (
                <span className={styles.badge}>
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </button>

        
          </>
        )}

        <Link
          to={baseRoute(WEB_ROUTES.SETTING)}
          className={styles.navIconButton}
          title="Settings"
          aria-label="Settings"
        >
          <IoIosSettings />
        </Link>

        <button
          type="button"
          className={styles.navIconButton}
          onClick={onLogoutClick}
          title="Logout"
          aria-label="Logout"
        >
          <TbLogout2 />
        </button>
      </div>

      {isAdmin && showPanel && (
        <NotificationPanel onClose={() => setShowPanel(false)} />
      )}
    </div>
  );
}
